export const ENERGY_HOME_VIEW_EVENT = 'CS/ENERGY_HOME_VIEW_EVENT';
export const ENERGY_OFFERS_FETCH_EVENT = 'CS/ENERGY_OFFERS_FETCH_EVENT';
export const ENERGY_OFFERS_FETCH = 'CS/ENERGY_OFFERS_FETCH';
export const ENERGY_OFFERS_FETCH_SUCCESS = 'CS/ENERGY_OFFERS_FETCH_SUCCESS';
export const ENERGY_OFFERS_FETCH_PENDING = 'CS/ENERGY_OFFERS_FETCH_PENDING';
export const ENERGY_OFFERS_FETCH_ERROR = 'CS/ENERGY_OFFERS_FETCH_ERROR';

export const ENERGY_FUTURE_DETAILS_FETCH = 'CS/ENERGY_FUTURE_DETAILS_FETCH';
export const ENERGY_FUTURE_DETAILS_FETCH_SUCCESS = 'CS/ENERGY_FUTURE_DETAILS_FETCH_SUCCESS';
export const ENERGY_FUTURE_DETAILS_FETCH_ERROR = 'CS/ENERGY_FUTURE_DETAILS_FETCH_ERROR';

export const ENERGY_CURRENT_DETAILS_FETCH = 'CS/ENERGY_CURRENT_DETAILS_FETCH';
export const ENERGY_CURRENT_DETAILS_FETCH_SUCCESS = 'CS/ENERGY_CURRENT_DETAILS_FETCH_SUCCESS';
export const ENERGY_CURRENT_DETAILS_FETCH_ERROR = 'CS/ENERGY_CURRENT_DETAILS_FETCH_ERROR';

// Energy Switch
export const ENERGY_SWITCH_NEW = 'CS/ENERGY_SWITCH_NEW';
export const ENERGY_SWITCH_NEW_SUCCESS = 'CS/ENERGY_SWITCH_NEW_SUCCESS';
export const ENERGY_SWITCH_NEW_ERROR = 'CS/ENERGY_SWITCH_NEW_ERROR';

export const ENERGY_SWITCH_COMPLETE = 'CS/ENERGY_SWITCH_COMPLETE';
export const ENERGY_SWITCH_COMPLETE_SUCCESS = 'CS/ENERGY_SWITCH_COMPLETE_SUCCESS';
export const ENERGY_SWITCH_COMPLETE_ERROR = 'CS/ENERGY_SWITCH_COMPLETE_ERROR';

export const ENERGY_SWITCH_SAVINGS_FETCH = 'CS/ENERGY_SWITCH_SAVINGS_FETCH';
export const ENERGY_SWITCH_SAVINGS_FETCH_SUCCESS = 'CS/ENERGY_SWITCH_SAVINGS_FETCH_SUCCESS';
export const ENERGY_SWITCH_SAVINGS_FETCH_ERROR = 'CS/ENERGY_SWITCH_SAVINGS_FETCH_ERROR';

export const ENERGY_SWITCH_REGIONS_FETCH = 'CS/ENERGY_SWITCH_REGIONS_FETCH';
export const ENERGY_SWITCH_REGIONS_FETCH_SUCCESS = 'CS/ENERGY_SWITCH_REGIONS_FETCH_SUCCESS';
export const ENERGY_SWITCH_REGIONS_FETCH_ERROR = 'CS/ENERGY_SWITCH_REGIONS_FETCH_ERROR';

export const ENERGY_SET_REGION = 'CS/ENERGY_SET_REGION';
export const ENERGY_SET_REGION_SUCCESS = 'CS/ENERGY_SET_REGION_SUCCESS';
export const ENERGY_SET_REGION_ERROR = 'CS/ENERGY_SET_REGION_ERROR';

export const ENERGY_SET_ADDRESS = 'CS/ENERGY_SET_ADDRESS';
export const ENERGY_SET_ADDRESS_SUCCESS = 'CS/ENERGY_SET_ADDRESS_SUCCESS';
export const ENERGY_SET_ADDRESS_ERROR = 'CS/ENERGY_SET_ADDRESS_ERROR';

export const ENERGY_SET_SELECTED_FUEL_TAB = 'CS/ENERGY_SET_SELECTED_FUEL_TAB';

export const ENERGY_SET_SELECTED_FUTURE_TARIFF_ID = 'CS/ENERGY_SET_SELECTED_FUTURE_TARIFF_ID';

export const ENERGY_SET_GAS_SUPPLIER = 'CS/ENERGY_SET_GAS_SUPPLIER';
export const ENERGY_SET_ELECTRIC_SUPPLIER = 'CS/ENERGY_SET_ELECTRIC_SUPPLIER';
export const ENERGY_SET_ENERGY_SUPPLIER = 'CS/ENERGY_SET_ENERGY_SUPPLIER';

export const ENERGY_RESET_GAS_TARIFF_ID = 'CS/ENERGY_RESET_GAS_TARIFF_ID';
export const ENERGY_RESET_ELECTRIC_TARIFF_ID = 'CS/ENERGY_RESET_ELECTRIC_TARIFF_ID';
export const ENERGY_RESET_ENERGY_TARIFF_ID = 'CS/ENERGY_RESET_ENERGY_TARIFF_ID';

export const ENERGY_FETCH_GAS_SUPPLIERS = 'CS/ENERGY_FETCH_GAS_SUPPLIERS';
export const ENERGY_FETCH_GAS_SUPPLIERS_SUCCESS = 'CS/ENERGY_FETCH_GAS_SUPPLIERS_SUCCESS';
export const ENERGY_FETCH_GAS_SUPPLIERS_ERROR = 'CS/ENERGY_FETCH_GAS_SUPPLIERS_ERROR';

export const ENERGY_FETCH_ELECTRIC_SUPPLIERS = 'CS/ENERGY_FETCH_ELECTRIC_SUPPLIERS';
export const ENERGY_FETCH_ELECTRIC_SUPPLIERS_SUCCESS = 'CS/ENERGY_FETCH_ELECTRIC_SUPPLIERS_SUCCESS';
export const ENERGY_FETCH_ELECTRIC_SUPPLIERS_ERROR = 'CS/ENERGY_FETCH_ELECTRIC_SUPPLIERS_ERROR';

export const ENERGY_FETCH_ENERGY_SUPPLIERS = 'CS/ENERGY_FETCH_ENERGY_SUPPLIERS';
export const ENERGY_FETCH_ENERGY_SUPPLIERS_SUCCESS = 'CS/ENERGY_FETCH_ENERGY_SUPPLIERS_SUCCESS';
export const ENERGY_FETCH_ENERGY_SUPPLIERS_ERROR = 'CS/ENERGY_FETCH_ENERGY_SUPPLIERS_ERROR';

export const ENERGY_FETCH_GAS_TARIFFS = 'CS/ENERGY_FETCH_GAS_TARIFFS';
export const ENERGY_FETCH_GAS_TARIFFS_SUCCESS = 'CS/ENERGY_FETCH_GAS_TARIFFS_SUCCESS';
export const ENERGY_FETCH_GAS_TARIFFS_ERROR = 'CS/ENERGY_FETCH_GAS_TARIFFS_ERROR';

export const ENERGY_FETCH_ELECTRIC_TARIFFS = 'CS/ENERGY_FETCH_ELECTRIC_TARIFFS';
export const ENERGY_FETCH_ELECTRIC_TARIFFS_SUCCESS = 'CS/ENERGY_FETCH_ELECTRIC_TARIFFS_SUCCESS';
export const ENERGY_FETCH_ELECTRIC_TARIFFS_ERROR = 'CS/ENERGY_FETCH_ELECTRIC_TARIFFS_ERROR';

export const ENERGY_FETCH_ENERGY_TARIFFS = 'CS/ENERGY_FETCH_ENERGY_TARIFFS';
export const ENERGY_FETCH_ENERGY_TARIFFS_SUCCESS = 'CS/ENERGY_FETCH_ENERGY_TARIFFS_SUCCESS';
export const ENERGY_FETCH_ENERGY_TARIFFS_ERROR = 'CS/ENERGY_FETCH_ENERGY_TARIFFS_ERROR';

export const ENERGY_STAGE_GO = 'CS/ENERGY_STAGE_GO';
export const ENERGY_STAGE_CHANGED = 'CS/ENERGY_STAGE_CHANGED';

export const ENERGY_UPDATE_FUEL_PREFERENCES = 'CS/ENERGY_UPDATE_FUEL_PREFERENCES';

export const ENERGY_FUTURE_SUPPLIER_FETCH = 'CS/ENERGY_FUTURE_SUPPLIER_FETCH';
export const ENERGY_FUTURE_SUPPLIER_FETCH_SUCCESS = 'CS/ENERGY_FUTURE_SUPPLIER_FETCH_SUCCESS';
export const ENERGY_FUTURE_SUPPLIER_FETCH_ERROR = 'CS/ENERGY_FUTURE_SUPPLIER_FETCH_ERROR';

export const ENERGY_FUTURE_SUPPLIER_CREATE = 'CS/ENERGY_FUTURE_SUPPLIER_CREATE';
export const ENERGY_FUTURE_SUPPLIER_CREATE_SUCCESS = 'CS/ENERGY_FUTURE_SUPPLIER_CREATE_SUCCESS';
export const ENERGY_FUTURE_SUPPLIER_CREATE_ERROR = 'CS/ENERGY_FUTURE_SUPPLIER_CREATE_ERROR';
